"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 10 04 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var utils_1 = require("../../core/utils");

var CategoryCleaningState_1 = require("../model/CategoryCleaningState");

var CategoryCleaningStateConverter_1 = require("./CategoryCleaningStateConverter");
/**
 * @author Jaroslav Sevcik
 * @author Radek Beran
 */


var CategoryCleaningStateConverterImpl =
/*#__PURE__*/
function (_CategoryCleaningStat) {
  _inherits(CategoryCleaningStateConverterImpl, _CategoryCleaningStat);

  function CategoryCleaningStateConverterImpl(validationResultConverter) {
    var _this;

    _classCallCheck(this, CategoryCleaningStateConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoryCleaningStateConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CategoryCleaningStateConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CategoryCleaningState_1.CategoryCleaningState(conversions.documentToClassId(source), conversions.asObject(source, 'categoryId', function (value) {
        return conversions.toClassReferenceId(value);
      }), source.cleaned, source.hasNewCompetitorPrices, conversions.asObjectList(source, 'suspiciousCRPCounts', function (obj) {
        return {
          priceZoneId: conversions.asObject(obj, 'priceZoneId', function (value) {
            return conversions.toClassReferenceId(value);
          }),
          suspiciousCRPCount: obj.suspiciousCRPCount
        };
      }), utils_1.Utils.isValueMissing(source.productMessages) ? ValidationResult_1.ValidationResult.EMPTY : this.validationResultConverter.toObject(source.productMessages, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        cleaned: source.cleaned,
        hasNewCompetitorPrices: source.hasNewCompetitorPrices,
        suspiciousCRPCounts: conversions.asObjectArray(source, 'suspiciousCRPCounts', function (obj) {
          return {
            priceZoneId: conversions.toDocumentReferenceId(obj.priceZoneId),
            suspiciousCRPCount: obj.suspiciousCRPCount
          };
        }),
        productMessages: this.validationResultConverter.toDocument(source.productMessages, conversions)
      });
      return result;
    }
  }]);

  return CategoryCleaningStateConverterImpl;
}(CategoryCleaningStateConverter_1.CategoryCleaningStateConverter);

CategoryCleaningStateConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter])], CategoryCleaningStateConverterImpl);
exports.CategoryCleaningStateConverterImpl = CategoryCleaningStateConverterImpl;